import {createSlice, PayloadAction, AnyAction} from '@reduxjs/toolkit';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';
import {IFooterGlobalDataState} from '../types/state';
import {TAppRootState} from 'core/redux/types';

export const footerGlobalModuleName = 'footerGlobal';

const initialState: IFooterGlobalDataState = {
    popularArticles: null,
    popularSections: null,
    socialNetworks: null,
};

export const footerGlobalSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            const footerState = payload[footerGlobalModuleName] as IFooterGlobalDataState | undefined;
            if (!footerState) {
                return state;
            }

            return {
                ...state,
                ...footerState,
                popularArticles: footerState.popularArticles ?? state.popularArticles,
                popularSections: footerState.popularSections ?? state.popularSections,
                socialNetworks: footerState.socialNetworks ?? state.socialNetworks,
            };
        });
    },
    initialState,
    name: footerGlobalModuleName,
    reducers: {
        actionSetPopularArticles(state, {payload}: PayloadAction<IFooterGlobalDataState['popularArticles']>) {
            state.popularArticles = payload;
        },
        actionSetPopularSections(state, {payload}: PayloadAction<IFooterGlobalDataState['popularSections']>) {
            state.popularSections = payload;
        },
        actionSetSocialNetworks(state, {payload}: PayloadAction<IFooterGlobalDataState['socialNetworks']>) {
            state.socialNetworks = payload;
        },
    },
});

export const {
    actions: {actionSetPopularArticles, actionSetPopularSections, actionSetSocialNetworks},
} = footerGlobalSlice;

export const {reducer: footerGlobalReducer} = footerGlobalSlice;

export const selectFooterPopularArticles = (state: TAppRootState) =>
    state[footerGlobalModuleName]?.popularArticles || null;
export const selectFooterPopularSections = (state: TAppRootState) =>
    state[footerGlobalModuleName]?.popularSections || null;
export const selectFooterSocialNetworks = (state: TAppRootState) =>
    state[footerGlobalModuleName]?.socialNetworks || null;
